<app-no-data-info [show]="!devicePieChartData.length"></app-no-data-info>
<ng-container *ngIf="devicePieChartData.length > 0">
    <app-pie-chart [data]="devicePieChartData" [height]="'650px'" [minRadius]="(mobile$ | async) ? 10 : 150"
        [fullPie]="true" [colors]="colors"></app-pie-chart>
</ng-container>